import { version } from "@/../package.json";

import paxios from "@/common/paxios";
import {
	isInternalAnchorElement,
	forceHistoryPushOnAnchorElement,
	openExternalLinkInNewTab,
	findAnchorElementFromEvent,
} from "@/common/functions";

export default {
	getDateByMilliseconds: function(value) {
		var date = new Date(value);
		let month_names = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		return (
			month_names[date.getMonth()] +
			" " +
			date.getDate() +
			", " +
			date.getFullYear()
		);
	},
	async getArticleData(slug) {
		this.isLoading = true;

		await paxios
			.get(
				`https://api.yourdictionary.com/cms/v1/wfa/article/.web.${slug}?v=${version}`
			)
			.then((response) => {
				if (response.status === 200 && response.data.status === 200) {
					this.article = response.data.data;
					const hideAds = (this.article?.flags || []).includes(
						"no-ads"
					);
					this.$store.commit("setHideArticleAds", hideAds);
				}
			})
			.catch(() => {
				this.isError = true;
				this.$store.commit("setHideArticleAds", false);
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	onBodyCopyClick(e) {
		e.preventDefault();

		const anchorElement = findAnchorElementFromEvent(e);

		if (isInternalAnchorElement(anchorElement)) {
			forceHistoryPushOnAnchorElement(
				anchorElement,
				this.$router.history
			);
			return;
		}

		openExternalLinkInNewTab(anchorElement, window);
	},
};
